import { Row } from 'react-styled-flexboxgrid';
import styled from 'styled-components';

import { media } from '@savgroup-front-common/constants';
import { fontStyle } from '@savgroup-front-common/core/theme/helpers/fontStyle';
import { fontWeight } from '@savgroup-front-common/primitive/helpers/fontWeight';
import { spacing } from '@savgroup-front-common/primitive/helpers/spacing';

export const $RowContainer = styled(Row)`
  flex-direction: column;
  align-items: center;
  margin-left: unset;
  margin-right: unset;
  h2 {
    text-align: center;
    font-weight: ${fontWeight('bold')};
    @media ${media.maxWidth.sm} {
      ${fontStyle('xl')};
    }
  }
  & > * {
    margin-top: ${spacing('xxl')};
  }
`;

export const $RowBannerContainer = styled(Row)`
  display: flex;
  justify-content: space-between;
  width: 100%;
  padding: ${spacing('xxl')};
  border-radius: ${({ theme }) => theme.tw.radius.lg};
  background: rgba(32, 93, 243, 0.05);
`;

export const $RowBannerContainerText = styled('div')`
  display: flex;
  flex-direction: column;
  justify-content: center;
  > * {
    &:first-child {
      font-weight: ${fontWeight('bold')};
    }
  }
`;

export const $RowBannerContent = styled(Row)`
  display: flex;
  flex-direction: row;
  margin-left: unset;
  margin-right: unset;
  @media ${media.maxWidth.sm} {
    text-align: center;
    justify-content: center;
    align-items: center;
  }
`;

export const $RowBannerContainerIcon = styled.div`
  display: flex;
  flex-direction: column;
  justify-self: center;
  margin-right: ${spacing('lg')};
  @media ${media.maxWidth.sm} {
    margin-bottom: ${spacing('lg')};
  }
`;

export const $RowBannerContainerButton = styled.div`
  display: flex;
  flex-direction: column;
  justify-self: flex-end;
  @media ${media.maxWidth.sm} {
    margin-top: ${spacing('lg')};
    width: 100%;
    justify-content: center;
    align-items: center;
  }
`;

export const $TextContainer = styled('div')`
  text-align: center;
`;

export const $ButtonOtherDemand = styled('div')`
  margin-top: ${spacing(12)};
`;
